<h2 mat-dialog-title>Send Bulk Email</h2>
<button type="button" class="btn btn-link modal-close" (click)="close()">
  <svg
    width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18 6L6 18" stroke="#03101F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M6 6L18 18" stroke="#03101F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
  </svg></button>
  <mat-dialog-content>
  <form [formGroup]="sendEmailForm">
    <div class="mat-account-wrapper">
      <div class="content-box non-tab send-bulk-email-tab p-0">
        <div class="row m-0">
            <div class="col-sm-6 mb-3">
                <div class="mb-0 mat-account-selectoption add-ticket-status">
                  <div class="d-flex">
                    <span class="black-text fs-14 mt-1">To</span> 
                      <mat-icon *ngIf="isForMatAccounts" class="my-1 fs-22 ms-2" matTooltipPosition="right" matTooltip="List of mat admin whose accounts are activated">info</mat-icon>
                      <mat-icon *ngIf="!isForMatAccounts" class="my-1 fs-22 ms-2" matTooltipPosition="right" matTooltip="List of school admin whose accounts are activated">info</mat-icon>  
                  </div> 
                  <mat-form-field>
                    <mat-select formControlName="selectedEmailIds" multiple (selectionChange)="isAllSelected()">
                      <button type="button" class="btn theme-btn pt-2 m-3" (click)="toggleSelectAll()">{{ allSelected ? 'Deselect All' : 'Select All' }}</button>
                      <mat-option *ngFor="let email of emailIds" [value]="email">
                        {{ email }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
            </div>
            <div class="col-sm-6 mb-3">
                <span class="black-text fs-14 mb-1">Content</span>
                <textarea formControlName="content" [required]="true" class="form-control" rows="3"></textarea>
            </div>         
        </div>
       </div>
    </div>
  </form>
  </mat-dialog-content>
  <mat-dialog-actions>
    <div class="row">
      <div class="col-md-6 offset-md-6">
        <div class="row">
          <div class="col-3 col-md-6 pe-2">
            <button type="button" class="btn theme-btn-outline w-100 pt-2" 
            (click)="close()">
              Cancel
            </button>
          </div>
          <div class="col-3 col-md-6 ps-2">
            <button type="button" class="btn theme-btn w-100 pt-2" [disabled]="isSendButtonDisabled" (click)="onSend()">
              Send
            </button>
          </div>
        </div>
      </div>
    </div>
  </mat-dialog-actions>